import { createActions } from "reduxsauce";

export default createActions(
  {
    displayModal: ["activeModalType"],
    closeModal: ["result"]
  },
  { prefix: "modal/" }
);



// WEBPACK FOOTER //
// ./src/modules/modal/modal-actions.js